import { List } from 'immutable';

import { localeMiddleware } from '../application/common/locale/loader';
import { queryMiddleware } from '../application/common/reportConfiguration/queryMiddleware';

import { reportQueryEffects } from './effects';

export const middleware = List([localeMiddleware, queryMiddleware(reportQueryEffects.query)]);
